document.documentElement.classList.add('pa-motion');

function initAdvisory(root = document) {
  root.querySelectorAll('[data-pa-hero]:not([data-pa-ready])').forEach((hero) => {
    hero.dataset.paReady = 'true';
    requestAnimationFrame(() => hero.classList.add('is-ready'));
  });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = root.querySelectorAll('.pa-reveal:not([data-pa-observed])');
  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    reveals.forEach((element) => {
      element.dataset.paObserved = 'true';
      revealObserver.observe(element);
    });
  }

  root.querySelectorAll('.pa-factor:not([data-pa-bound])').forEach((factor) => {
    factor.dataset.paBound = 'true';
    const activate = () => {
      factor.closest('.pa-factors')?.querySelectorAll('.pa-factor').forEach((item) => item.classList.toggle('is-active', item === factor));
    };
    factor.addEventListener('pointerenter', activate);
    factor.addEventListener('focus', activate);
    factor.addEventListener('click', activate);
  });

  const benefits = root.querySelectorAll('.pa-benefit:not([data-pa-benefit])');
  if (benefits.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      benefits.forEach((benefit) => benefit.classList.add('is-active'));
    } else {
      const benefitObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const group = entry.target.closest('.pa-benefits');
          group?.querySelectorAll('.pa-benefit').forEach((item) => item.classList.toggle('is-active', item === entry.target));
        });
      }, { threshold: 0.55, rootMargin: '-18% 0px -28% 0px' });
      benefits.forEach((benefit) => {
        benefit.dataset.paBenefit = 'true';
        benefitObserver.observe(benefit);
      });
    }
  }

  root.querySelectorAll('[data-pa-faq]:not([data-pa-bound])').forEach((button) => {
    button.dataset.paBound = 'true';
    button.addEventListener('click', () => {
      const item = button.closest('.pa-faq__item');
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      item.classList.toggle('is-open', !open);
      const answer = document.getElementById(button.getAttribute('aria-controls'));
      answer?.setAttribute('aria-hidden', String(open));
    });
  });

  root.querySelectorAll('[data-pa-call]:not([data-pa-bound])').forEach((call) => {
    call.dataset.paBound = 'true';
    call.addEventListener('pointerdown', () => {
      call.classList.remove('is-tapped');
      requestAnimationFrame(() => call.classList.add('is-tapped'));
      window.setTimeout(() => call.classList.remove('is-tapped'), 420);
    });
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAdvisory());
else initAdvisory();
document.addEventListener('shopify:section:load', (event) => initAdvisory(event.target));
